import React from "react";
import { Route } from "react-router";
import configureStore from "./store/configureStore";

import { getAccountDetails, getLoggedInUser } from "./actions/userActions";
import { getSignupOptions } from "./actions/signupActions";
import { loadContent } from "./actions/contentActions";
import { loadSession } from "./actions/sessionActions";
import { loadMetadata } from "./actions/metadataActions";
import { loadDiagram } from "./actions/diagramActions";
import {
  getTrainingGroundPopularSearches,
  loadTrainingGroundContentFeed,
} from "./actions/trainingGroundActions";
import { getAllocatedLicences, getLicenceInfo } from "./actions/licenceActions";
import {
  getStripeCustomerFuturePayment,
  getStripeCustomerPaymentHistory,
} from "./actions/stripeActions";
import { loadTrendingSearches } from "./actions/searchActions";
import { canIAccess } from "./actions/accessActions";
import { getOrganisation } from "./actions/organisationActions";
import { getPaymentBilling } from "./actions/billingActions";

import App from "./components/App";
import SignupPage from "./components/Signup/SignupPage";
import SearchPage from "./components/Search/SearchPage";
import TrainingGroundPage from "./components/TrainingGround/TrainingGroundPage";
import CreatePage from "./components/Create/CreatePage";
import ManageContentPage from "./components/Create/ManageContentPage";
import DrillPage from "./components/Drill/DrillPage";
import SessionPage from "./components/Session/SessionPage";
import DiagramCreatorPage from "./components/Diagram/DiagramCreatorPage";
import AccountDetailsPage from "./components/Account/AccountDetails/AccountDetailsPage";
import LicenceManagerPage from "./components/Account/LicenceManager/LicenceManagerPage";
import YourPlanPage from "./components/Account/YourPlan/YourPlanPage";
import PaymentHistoryPage from "./components/Account/PaymentHistory/PaymentHistoryPage";
import FourOFourPage from "./components/Errors/FourOFourPage";
import { getAvailableFolderAccessors, loadFolderV3 } from "./actions/folderActions";
import FoldersPage from "./components/Folders/FoldersPage";

export const store = configureStore();

export const routes = (
  <Route
    path={`/`}
    component={App}
    onEnter={() => {
      store.dispatch(getOrganisation());
      store.dispatch(getLoggedInUser());

      // setTimeout(() => {
      //   store.dispatch(getOrganisation());
      // }, 10000);
      // store.dispatch(getLoggedInUser());
    }}
  >
    <Route
      path={`signup`}
      component={SignupPage}
      onEnter={() => {
        store.dispatch(getSignupOptions());
      }}
    />
    <Route path={`search`} component={SearchPage} />
    <Route
      path={`training-ground`}
      component={TrainingGroundPage}
      onEnter={() => {
        store.dispatch(loadTrainingGroundContentFeed());
        store.dispatch(getTrainingGroundPopularSearches());
        store.dispatch(loadTrendingSearches());
      }}
    />
    <Route path={`locker/my-content`} component={CreatePage} />
    <Route
      path={`locker/my-content/practice(/:id)`}
      component={ManageContentPage}
      onEnter={(nextState) => {
        if (nextState.params.id) {
          store.dispatch(loadContent(nextState.params.id));
        }
        store.dispatch(loadMetadata(`phaseofthegame`));
        store.dispatch(loadMetadata(`theme`));
        store.dispatch(loadMetadata(`typeofpractice`));
        store.dispatch(loadMetadata(`stageofpractice`));
        store.dispatch(loadMetadata(`unitfocus`));
        store.dispatch(loadMetadata(`areaofpitch`));
      }}
    />
    <Route
      path={`locker/my-content/document(/:id)`}
      component={ManageContentPage}
      onEnter={(nextState) => {
        if (nextState.params.id) {
          store.dispatch(loadContent(nextState.params.id));
        }
        store.dispatch(loadMetadata(`phaseofthegame`));
        store.dispatch(loadMetadata(`theme`));
        store.dispatch(loadMetadata(`typeofpractice`));
        store.dispatch(loadMetadata(`stageofpractice`));
        store.dispatch(loadMetadata(`unitfocus`));
        store.dispatch(loadMetadata(`areaofpitch`));
      }}
    />
    <Route
      path={`locker/my-content/diagram(/:id)`}
      component={DiagramCreatorPage}
      onEnter={(nextState) => {
        if (nextState.params.id) {
          store.dispatch(loadDiagram(nextState.params.id));
        } else {
          store.dispatch(loadMetadata(`pitchtheme`));
          store.dispatch(loadMetadata(`pitchimage`));
        }
      }}
    />
    {/* <Route
      path={'manage'}
      component={ManagePage}
    /> */}
    {/* <Route
      path={'organise'}
      component={OrganisePage}
    /> */}
    <Route
      path={`locker/folders`}
      component={FoldersPage}
      onEnter={() => {
        store.dispatch(loadFolderV3());
        store.dispatch(getAvailableFolderAccessors());
      }}
    />
    <Route
      path={`Content/:id`}
      component={DrillPage}
      onEnter={(nextState) => {
        store.dispatch(loadContent(nextState.params.id));
        store.dispatch(canIAccess(nextState.params.id, `Content`));
      }}
    />
    <Route
      path={`Session/:id`}
      component={SessionPage}
      onEnter={(nextState) => {
        store.dispatch(loadSession(nextState.params.id));
      }}
    />
    <Route
      path={`diagram/:id`}
      component={DrillPage}
      onEnter={(nextState) => {
        store.dispatch(loadDiagram(nextState.params.id));
        store.dispatch(canIAccess(nextState.params.id, `Content`));
      }}
    />
    <Route
      path={`account/details`}
      component={AccountDetailsPage}
      onEnter={() => {
        store.dispatch(getAccountDetails());
      }}
    />
    <Route
      path={`account/licence-manager`}
      component={LicenceManagerPage}
      onEnter={() => {
        store.dispatch(getLicenceInfo());
        store.dispatch(getAllocatedLicences(1, `first-name`));
      }}
    />
    <Route
      path={`account/plan`}
      component={YourPlanPage}
      onEnter={() => {
        store.dispatch(getSignupOptions());
        // store.dispatch(getStripeCustomerDetails());
        store.dispatch(getPaymentBilling());
      }}
    />
    {/* <Route */}
    {/*  path={`account/billing`} */}
    {/*  component={BillingDetailsPage} */}
    {/*  onEnter={() => { */}
    {/*    store.dispatch(getStripeCustomerDetails()); */}
    {/*  }} */}
    {/* /> */}
    <Route
      path={`account/billing/payment-history`}
      component={PaymentHistoryPage}
      onEnter={() => {
        store.dispatch(getStripeCustomerPaymentHistory());
        store.dispatch(getStripeCustomerFuturePayment());
      }}
    />
    <Route
      path={`payment-plans`}
      component={SignupPage}
      onEnter={() => {
        store.dispatch(getSignupOptions());
      }}
    />
    <Route
      path={`404`}
      component={FourOFourPage}
      onEnter={() => {
        store.dispatch(loadTrendingSearches());
      }}
    />

    {/* This <Route> catches any routes that haven't been declared above and allows them to render App.js */}
    {/* Has to be the last route. Used to render <Header> on legacy server rendered pages */}
    <Route path={`*`} />
  </Route>
);



// WEBPACK FOOTER //
// ./library/app/routes.js